import { RouteConfig } from 'vue-router'
const WinterCardLanding = () => import('../activity/202401/winter-holiday-card/Landing.vue')
const WinterCardIndex = () => import('../activity/202401/winter-holiday-card/Index.vue')

const DragonDateIndex = () => import('../activity/202401/dragon-gate/Index.vue')

export const A202401WinterCardLandingRoute: RouteConfig = {
  path: '/activity/202401/winter-card-landing',
  name: 'activity_202401_winter_card_landing',
  component: WinterCardLanding,
  meta: {
    title: '寒假会员双月卡',
  },
  props: (route) => ({ ...route.query }),
}

export const A202401WinterCardIndexRoute: RouteConfig = {
  path: '/activity/202401/winter-card-index',
  name: 'activity_202401_winter_card_index',
  component: WinterCardIndex,
  meta: {
    title: '寒假会员双月卡',
  },
}
export const A202401DragonDateIndex: RouteConfig = {
  path: '/activity/202401/dragon-gate',
  name: 'activity_202401_dragon_gate',
  component: DragonDateIndex,
  meta: {
    title: '龙年鲤鱼跳龙门',
  },
}

export default [A202401WinterCardLandingRoute, A202401WinterCardIndexRoute, A202401DragonDateIndex]
